export const FORGOT_PIN_EMAIL = "FORGOT_PIN_EMAIL";
export const FORGOT_PIN_EMAIL_SUCCESS = "FORGOT_PIN_EMAIL_SUCCESS";
export const FORGOT_PIN_EMAIL_ERROR = "FORGOT_PIN_EMAIL_ERROR";
export const RESET_PIN = "RESET_PIN";
export const RESET_PIN_SUCCESS = "RESET_PIN_SUCCESS";
export const RESET_PIN_ERROR = "RESET_PIN_ERROR";
